import { type ReactNode } from 'react';
import { useMsal } from '@azure/msal-react';
import { inIframe } from '../../auth/loginHelpers';
import styles from './ModulePane.module.css';

type ModulePaneProps = {
  sidebar: ReactNode;
  children: ReactNode;
  ariaLabel?: string;
};

/**
 * Two-column module shell: a local sidebar (nav/filters) + the main
 * content pane. When iframed inside i-broker we DON'T render the brand
 * header (i-broker shows its own chrome); standalone we show a compact
 * brand header so the app is usable on its own. Mirrors Pipeline's
 * ModulePane.
 */
export function ModulePane({ sidebar, children, ariaLabel }: ModulePaneProps) {
  const { accounts } = useMsal();
  const account = accounts[0];

  return (
    <div className={styles.shell}>
      <aside className={styles.sidebar} aria-label={ariaLabel ?? 'Navigation'}>
        {!inIframe && (
          <div className={styles.brand}>
            <div className={styles.brandName}>Compose</div>
            {account && (
              <div className={styles.brandUser} title={account.username}>
                {account.name ?? account.username}
              </div>
            )}
          </div>
        )}
        <div className={styles.sidebarInner}>{sidebar}</div>
      </aside>
      <main className={styles.main}>{children}</main>
    </div>
  );
}
